import { PropertyMapper } from '../../decorators';

export class DeliveryType {

    @PropertyMapper()
    id: number;

    @PropertyMapper()
    name: string;
}
